import { SvgIconComponent } from '@mui/icons-material';
import PauseCircleOutlineRoundedIcon from '@mui/icons-material/PauseCircleOutlineRounded';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

export enum CancelFlowStep {
  RETENTION = 'retention',
  PAUSE_DURATION = 'pause_duration',
  FINAL_CONFIRMATION = 'final_confirmation'
}

export enum RetentionOption {
  PAUSE = 'pause',
  TRAINING = 'training',
  CANCEL = 'cancel'
}

export enum PauseDurationValue {
  ONE_MONTH = '1_month',
  TWO_MONTHS = '2_months',
  CUSTOM = 'custom'
}

export const PAUSE_DURATION_OPTIONS = [
  {
    value: PauseDurationValue.ONE_MONTH,
    label: '1 Month'
  }
  // {
  //   value: PauseDurationValue.TWO_MONTHS,
  //   label: '2 Months'
  // },
  // {
  //   value: PauseDurationValue.CUSTOM,
  //   label: 'Custom Duration'
  // }
];

export const RETENTION_OPTIONS: Array<{
  value: RetentionOption;
  title: string;
  description: string;
  icon: SvgIconComponent;
  iconColor: 'primary' | 'warning';
  recommended?: boolean;
}> = [
  {
    value: RetentionOption.PAUSE,
    title: 'Pause Subscription',
    description: 'Take a break without losing your data/settings.',
    icon: PauseCircleOutlineRoundedIcon,
    iconColor: 'primary',
    recommended: true
  },
  {
    value: RetentionOption.TRAINING,
    title: 'Need Training / Support',
    description: 'Schedule a quick session with our team.',
    icon: SchoolOutlinedIcon,
    iconColor: 'primary'
  },
  {
    value: RetentionOption.CANCEL,
    title: 'Still want to cancel',
    description: 'Continue to the final cancellation confirmation.',
    icon: WarningAmberRoundedIcon,
    iconColor: 'warning'
  }
];
